import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import Price from "@icons/price.svg?react";
import Star from "@icons/star.svg?react";
import Crown from "@icons/crown.svg?react";

interface GameFiltersProps {
  activeFilter: 'all' | 'free' | 'popular' | 'recommended';
  onFilterChange: (filter: 'all' | 'free' | 'popular' | 'recommended') => void;
}

export function GameFilters({ activeFilter, onFilterChange }: GameFiltersProps) {
  return (
    <div className="flex flex-wrap gap-2 mb-6" data-goal-id="game_filters_clicked">
      <motion.div whileHover={{ scale: 1.05 }}>
        <Button
          variant={activeFilter === 'all' ? 'outlineActive' : 'outline'}
          onClick={() => onFilterChange('all')}
          className="rounded-3xl md:p-3 p-2"
        >
          Все игры
        </Button>        
      </motion.div>
      <motion.div whileHover={{ scale: 1.05 }}>
        <Button
          variant={activeFilter === 'free' ? 'outlineActive' : 'outline'}
          onClick={() => onFilterChange('free')}
          className="rounded-3xl md:p-3 p-2"
        >
          <Price className="w-5 h-5" />
          Бесплатные
        </Button>
      </motion.div>
      <motion.div whileHover={{ scale: 1.05 }}>
        <Button
          variant={activeFilter === 'popular' ? 'outlineActive' : 'outline'}
          onClick={() => onFilterChange('popular')}
          className="rounded-3xl md:p-3 p-2"
        >
          <Crown className="w-5 h-5" />
          Популярные
        </Button>
      </motion.div>
      <motion.div whileHover={{ scale: 1.05 }}>
        <Button
          variant={activeFilter === 'recommended' ? 'outlineActive' : 'outline'}
          onClick={() => onFilterChange('recommended')}
          className="rounded-3xl md:p-3 p-2"
        >
          <Star className="w-5 h-5" />
          Рекомендуемые
        </Button>        
      </motion.div>
    </div>
  );
}
